<template>
  <div class="fishki">

    <div class="price-block" v-show="false">
      <div class="price-row">
        <p>Стоимость товаров:</p>
        <p class="price-value">{{ order.producttotal.toLocaleString('ru-RU') }} ₽</p>
      </div>
    </div>
    

    <div class="price-block" v-if="['club-owner','club-manager'].includes(role) && sklad1c == '2-Готовая продукция' && !order.pereezd">
      <div class="price-row">
        <p>Стоимость доставки:</p>
        <p class="price-value">{{ user.armpoint.delivery.costprice.toLocaleString('ru-RU') }} ₽</p>
      </div>
    </div>
    

    <div class="bonus-block" v-if="activity && client._id !== '62fd6ad64886f195911e7395'">

      <div class="bonus-section" v-if="proverkaPokaza">
        <div class="promocode-row">
          <input 
            type="text" 
            placeholder="Сертификат или промокод" 
            v-model="fishki.promocode.t"
            class="promocode-input"
          >
          <button 
            @click="getPromocodes()" 
            class="promocode-btn"
          >
            →
          </button>
        </div>
      </div>


      <div class="bonus-row" :class="{ disabled: fishkiUser().bonus == 0 }" v-if="fishkiUser().bonus !== 0">
        <div class="bonus-left">
          <div 
            class="checkbox" 
            :class="{ checked: order.bonus !== 0 }"
            @click="order.bonus !== 0 ? changeBonus(0) : changeBonus(fishkiUser().bonus.value)"
          ></div>
          <span class="bonus-label">Списать бонусы</span>
        </div>
        <span class="bonus-amount">{{ order.bonus !== 0 ? order.bonus : fishkiUser().bonus.value }}</span>
      </div>

 
      <div class="bonus-row" :class="{ disabled: fishkiUser().avans == 0 }" v-if="fishkiUser().avans !== 0 && !['club-owner','club-manager'].includes(role)">
        <div class="bonus-left">
          <div 
            class="checkbox" 
            :class="{ checked: order.avanse !== 0 }"
            @click="order.avanse !== 0 ? changeAvanse(0) : changeAvanse(fishkiUser().avans.value)"
          ></div>
          <span class="bonus-label">Списать депозит</span>
        </div>
        <span class="bonus-amount">{{ fishkiUser().avans }}</span>
        <input 
          type="number" 
          @change="proverkaAvans()" 
          v-if="order.avanse !== 0" 
          v-model="order.avanse" 
          class="amount-input"
        >
      </div>
      
   
      <div class="bonus-row" :class="{ disabled: fishkiUser().ad_deposit == 0 }" v-if="fishkiUser().ad_deposit !== 0 && !['club-owner','club-manager'].includes(role)">
        <div class="bonus-left">
          <div 
            class="checkbox" 
            :class="{ checked: order.ad_deposit !== 0 }"
            @click="order.ad_deposit !== 0 ? changeDeposit(0) : changeDeposit(fishkiUser().ad_deposit.value)"
          ></div>
          <span class="bonus-label">Ultimatum Select</span>
        </div>
        <span class="bonus-amount">{{ fishkiUser().ad_deposit }}</span>
        <input 
          type="number" 
          @change="proverkaDeposit()" 
          v-if="order.ad_deposit !== 0" 
          v-model="order.ad_deposit" 
          class="amount-input"
        >
      </div>
    </div>

   
    <div class="total-block">
      <div class="total-row">
        <p>Итого к оплате:</p>
        <p class="total-price">{{ order.paymentorder.payment.toLocaleString('ru-RU') }} ₽</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { client, updateLogin, activity } from '@/controlles/client'
import { order, fishkiUser, changeBonus, changeAvanse, changeDeposit, promocodeUse } from '@/controlles/basket/basket'
import { reactive, computed } from 'vue'
import { notSet } from '@/controlles/general'
import axios from 'axios'
import { role, user, sklad1c } from '@/controlles/auth'

const proverkaPokaza = computed(() => {
  if (['club-owner','club-manager'].includes(role.value)) {
    if (user.value.armpoint.skidka && user.value.armpoint.skidka !== 0) {
      return false
    }
  }
  return true
})

const fishki = reactive({
  promocode: { a: false, p: 0, t: '', l: false, d: 0 }
})

const proverkaAvans = () => {
  if (order.avanse > fishkiUser().avans.value) {
    order.avanse = fishkiUser().avans.value
  }
}

const proverkaDeposit = () => {
  if (order.ad_deposit > fishkiUser().ad_deposit.value) {
    order.ad_deposit = fishkiUser().ad_deposit.value
  }
}

const getPromocodes = async () => {
  try {
    const proVV = await axios.post('https://api.ultimatum.store/certificates/activate', {
      id: client.value._id,
      code: fishki.promocode.t,
      total: order.paymentorder.payment
    })
    if (proVV.type == 'ce') {
      await updateLogin(client.value.phone, 'phone')
      notSet('Код активирован')
    }
    if (proVV.type == 'pro') {
      if (proVV.data.refferal !== null) {
        order.refferal = proVV.data.refferal
      }
      await promocodeUse(proVV.data)
      notSet('Код активирован')
    }
  } catch (e) {
    notSet('Такого кода нет')
    console.log(e)
  }
}
</script>

<style scoped>
.fishki {
  width: 100%;
  display: flex;
  flex-direction: column;
}

/* Блоки с ценами (как стоимость товаров) */
.price-block {
  width: 100%;
  border-bottom: 1px solid var(--border-light);
  background: var(--bg-primary);
}

.price-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  width: 100%;
}

.price-row p {
  font-size: 16px;
  font-weight: 400;
  color: var(--text-primary);
  margin: 0;
}

.price-value {
  font-weight: 600;
  color: var(--accent-black);
}

/* Блок с бонусами */
.bonus-block {
  width: 100%;
  background: var(--bg-secondary);
  border-bottom: 1px solid var(--border-light);
}

.bonus-section {
  padding: 16px 20px;
  border-bottom: 1px solid var(--border-light);
}

.bonus-section:last-child {
  border-bottom: none;
}

/* Промокод */
.promocode-row {
  display: flex;
  gap: 8px;
  width: 100%;
}

.promocode-input {
  flex: 1;
  padding: 12px 16px;
  background: var(--bg-primary);
  border: 1px solid var(--border-medium);
  font-size: 14px;
  color: var(--text-primary);
  transition: all var(--transition-fast);
      margin-bottom: 0;
}

.promocode-input:focus {
  outline: none;
  border-color: var(--accent-black);
}

.promocode-input::placeholder {
  color: var(--text-tertiary);
}

.promocode-btn {
  width: 48px;
  height: 43px;
  background: var(--accent-black);
  color: var(--text-inverse);
  border: 1px solid var(--accent-black);
  font-size: 20px;
  cursor: pointer;
  transition: all var(--transition-fast);
  display: flex;
  align-items: center;
  justify-content: center;
}

.promocode-btn:hover {
  background: var(--btn-accent-hover);
  border-color: var(--btn-accent-hover);
}

/* Строка бонуса */
.bonus-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid var(--border-light);
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
}

.bonus-row:last-child {
  border-bottom: none;
}

.bonus-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.checkbox {
  width: 24px;
  height: 24px;
  border: 2px solid var(--border-medium);
  background: var(--bg-primary);
  cursor: pointer;
  transition: all var(--transition-fast);
}

.checkbox.checked {
  background: var(--accent-black);
  border-color: var(--accent-black);
  position: relative;
}

.checkbox.checked::after {
  content: '✓';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: var(--text-inverse);
  font-size: 16px;
  font-weight: 600;
}

.bonus-label {
  font-size: 15px;
  font-weight: 400;
  color: var(--text-primary);
}

.bonus-amount {
  font-size: 16px;
  font-weight: 600;
  color: var(--accent-black);
  min-width: 60px;
  text-align: right;
}

/* Инпут для суммы */
.amount-input {
  width: 100%;
  padding: 10px 14px;
  background: var(--bg-primary);
  border: 1px solid var(--border-medium);
  font-size: 14px;
  color: var(--text-primary);
  margin-top: 8px;
}

.amount-input:focus {
  outline: none;
  border-color: var(--accent-black);
}

/* Отключенные элементы */
.disabled {
  opacity: 0.5;
  pointer-events: none;
}

/* Итого */
.total-block {
  width: 100%;
  background: var(--bg-secondary);
  border-top: 1px solid var(--border-medium);
}

.total-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  width: 100%;
}

.total-row p {
  font-size: 16px;
  font-weight: 400;
  color: var(--text-primary);
  margin: 0;
}

.total-price {
  font-size: 22px;
  font-weight: 700;
  color: var(--accent-black);
}

/* Темная тема */
html.dark .promocode-btn {
  background: var(--accent-black);
  border-color: var(--accent-black);
}

html.dark .checkbox.checked {
  background: var(--accent-black);
  border-color: var(--accent-black);
}

html.dark .total-block {
  background: var(--bg-tertiary);
}

</style>